import React, { useState } from 'react';
import { compose } from 'redux';
import { injectIntl } from '../../util/reactIntl';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { withViewport } from '../../util/contextHelpers';
import config from '../../config';
import { isScrollingDisabled } from '../../ducks/UI.duck';
import {
  Footer,
  LayoutSingleColumn,
  LayoutWrapperFooter,
  LayoutWrapperMain,
  LayoutWrapperTopbar,
  Page,
  FaqDropdown,
  JoinPreFooter,
  Logo,
  NamedLink,
} from '../../components';
import { TopbarContainer } from '..';
import { FormattedMessage } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import { IoIosArrowDown, IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import { FaCircleCheck } from 'react-icons/fa6';
import { LiaCoinsSolid } from 'react-icons/lia';

import css from './PricingPage.css';
import collabImage from '../../assets/start-buying-info2.png';
import collabImageEN from '../../assets/start-buying-info2-en.png';
import testimonialImg from '../../assets/katariina-sommerschield-quote.png';

export const PricingPageComponent = props => {
  const { intl, scrollingDisabled, history, location, viewport } = props;

  const siteTitle = config.siteTitle;
  const schemaTitle = intl.formatMessage({ id: 'PricingPage.schemaTitle' }, { siteTitle });
  const schemaDescription = intl.formatMessage({ id: 'PricingPage.schemaDescription' });
  const locale = config.locale;

  // Choose image based on locale
  const collabImageToUse = locale === 'en' ? collabImageEN : collabImage;

  // Open the Intercom Messenger for the "quick cost estimate" CTA
  const handleContactClick = () => {
    if (typeof window === 'object' && window.Intercom) {
      window.Intercom('showSpace', 'home');
    }
  };

  const faqQuestion1 = <FormattedMessage id="PricingPage.faqQuestion1" />;
  const faqQuestion2 = <FormattedMessage id="PricingPage.faqQuestion2" />;
  const faqQuestion3 = <FormattedMessage id="PricingPage.faqQuestion3" />;

  const faqAnswer1 = (
    <div>
      <FormattedMessage id="PricingPage.faqAnswer1" />
    </div>
  );

  const faqAnswer2 = (
    <div>
      <FormattedMessage id="PricingPage.faqAnswer2" />
    </div>
  );

  const faqAnswer3 = (
    <div>
      <FormattedMessage id="PricingPage.faqAnswer3" />
    </div>
  );

  const [faqIsShown, setFaqIsShown] = useState([
    {
      question: faqQuestion1,
      answer: faqAnswer1,
      index: 0,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion2,
      answer: faqAnswer2,
      index: 1,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
    {
      question: faqQuestion3,
      answer: faqAnswer3,
      index: 2,
      isShow: false,
      arrow: <IoIosArrowDown />,
    },
  ]);

  return (
    <Page
      className={css.root}
      scrollingDisabled={scrollingDisabled}
      contentType="website"
      description={schemaDescription}
      title={schemaTitle}
      schema={{
        '@context': 'http://schema.org',
        '@type': 'WebPage',
        description: schemaDescription,
        name: schemaTitle,
      }}
    >
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopbarContainer currentPage="PricingPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <ul className={css.sections}>
            <li className={css.section}>
              <div className={css.heroSection}>
                <div className={css.heroBadge}>
                  <LiaCoinsSolid className={css.heroBadgeIcon} />
                  <FormattedMessage id="PricingPage.heroBadge" />
                </div>
                <h1 className={css.heroTitle}>
                  <FormattedMessage
                    id="PricingPage.heroTitle"
                    values={{
                      b: chunks => <p className={css.heroTitleBlue}>{chunks}</p>,
                    }}
                  />
                </h1>
                <p className={css.heroSubtitle}>
                  <FormattedMessage id="PricingPage.heroSubtitle" />
                </p>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.pricingCard}>
                <h2 className={css.pricingTitle}>
                  <FormattedMessage id="PricingPage.pricingTitle" />
                </h2>
                <div className={css.pricingTiers}>
                  <div className={css.pricingTier}>
                    <h3 className={css.tierLevel}>
                      <FormattedMessage id="PricingPage.tierJunior" />
                    </h3>
                    <div className={css.tierPrice}>
                      <span className={css.priceAmount}>
                        <FormattedMessage id="PricingPage.priceJunior" />
                      </span>
                      <span className={css.priceUnit}>
                        <FormattedMessage id="PricingPage.priceUnit" />
                      </span>
                    </div>
                    <p className={css.tierDescription}>
                      <FormattedMessage id="PricingPage.tierJuniorDesc" />
                    </p>
                  </div>
                  <div className={css.pricingTier}>
                    <h3 className={css.tierLevel}>
                      <FormattedMessage id="PricingPage.tierMid" />
                    </h3>
                    <div className={css.tierPrice}>
                      <span className={css.priceAmount}>
                        <FormattedMessage id="PricingPage.priceMid" />
                      </span>
                      <span className={css.priceUnit}>
                        <FormattedMessage id="PricingPage.priceUnit" />
                      </span>
                    </div>
                    <p className={css.tierDescription}>
                      <FormattedMessage id="PricingPage.tierMidDesc" />
                    </p>
                  </div>
                  <div className={css.pricingTier}>
                    <h3 className={css.tierLevel}>
                      <FormattedMessage id="PricingPage.tierSenior" />
                    </h3>
                    <div className={css.tierPrice}>
                      <span className={css.priceAmount}>
                        <FormattedMessage id="PricingPage.priceSenior" />
                      </span>
                      <span className={css.priceUnit}>
                        <FormattedMessage id="PricingPage.priceUnit" />
                      </span>
                    </div>
                    <p className={css.tierDescription}>
                      <FormattedMessage id="PricingPage.tierSeniorDesc" />
                    </p>
                  </div>
                </div>
                <p className={css.pricingNote}>
                  <FormattedMessage id="PricingPage.pricingNote" />
                </p>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.estimateSection}>
                <div className={css.estimateContent}>
                  <div className={css.estimateTextBlock}>
                    <h2 className={css.estimateTitle}>
                      <FormattedMessage id="PricingPage.estimateTitle" />
                    </h2>
                    <p className={css.estimateDescription}>
                      <FormattedMessage id="PricingPage.estimateDescription" />
                    </p>
                  </div>
                  <button type="button" className={css.estimateButton} onClick={handleContactClick}>
                    <FormattedMessage id="PricingPage.estimateButton" />
                  </button>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.collabCard}>
                <div className={css.collabImageContainer}>
                  <img src={collabImageToUse} alt="Collaboration" className={css.collabImage} />
                </div>
                <div className={css.collabContent}>
                  <div className={css.collabTextBlock}>
                    <p className={css.collabEyebrow}>
                      <FormattedMessage id="PricingPage.collabEyebrow" />
                    </p>
                    <h2 className={css.collabTitle}>
                      <FormattedMessage id="PricingPage.collabTitle" />
                    </h2>
                    <p className={css.collabDescription}>
                      <FormattedMessage id="PricingPage.collabDescription" />
                    </p>
                  </div>
                  <NamedLink name="SignupPage" className={css.collabButton}>
                    <FormattedMessage id="PricingPage.collabButton" />
                  </NamedLink>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.flexibilitySection}>
                <h2 className={css.flexibilityTitle}>
                  <FormattedMessage id="PricingPage.flexibilityTitle" />
                </h2>
                <p className={css.flexibilitySubtitle}>
                  <FormattedMessage id="PricingPage.flexibilitySubtitle" />
                </p>
                <div className={css.flexibilityOptions}>
                  <div className={css.flexibilityOption}>
                    <div className={css.flexibilityIcon}>
                      <FaCircleCheck className={css.flexibilityIconCheck} />
                    </div>
                    <p className={css.flexibilityText}>
                      <FormattedMessage id="PricingPage.flexibilityOption1" />
                    </p>
                  </div>
                  <div className={css.flexibilityOption}>
                    <div className={css.flexibilityIcon}>
                      <FaCircleCheck className={css.flexibilityIconCheck} />
                    </div>
                    <p className={css.flexibilityText}>
                      <FormattedMessage id="PricingPage.flexibilityOption2" />
                    </p>
                  </div>
                  <div className={css.flexibilityOption}>
                    <div className={css.flexibilityIcon}>
                      <FaCircleCheck className={css.flexibilityIconCheck} />
                    </div>
                    <p className={css.flexibilityText}>
                      <FormattedMessage id="PricingPage.flexibilityOption3" />
                    </p>
                  </div>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.testimonialSection}>
                <img src={testimonialImg} alt="Testimonial" className={css.testimonialImage} />
                <div className={css.testimonialContent}>
                  <p className={css.testimonialQuote}>
                    <FormattedMessage id="PricingPage.testimonialQuote" />
                  </p>
                  <p className={css.testimonialName}>
                    <FormattedMessage id="PricingPage.testimonialName" />
                  </p>
                  <p className={css.testimonialTitle}>
                    <FormattedMessage id="PricingPage.testimonialTitle" />
                  </p>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.comparisonSection}>
                <h2 className={css.comparisonTitle}>
                  <FormattedMessage id="PricingPage.comparisonTitle" />
                </h2>
                <p className={css.comparisonSubtitle}>
                  <FormattedMessage
                    id="PricingPage.comparisonSubtitle"
                    values={{
                      b: chunks => <span className={css.comparisonSubtitleBlue}>{chunks}</span>,
                    }}
                  />
                </p>
                <div className={css.comparisonTable}>
                  <div className={css.comparisonTableInner}>
                    <div className={css.comparisonHeader}>
                      <div className={css.comparisonHeaderCell}></div>
                      <div className={css.comparisonHeaderCellFreedomly}>
                        <Logo format="desktop" className={css.logo} />
                      </div>
                      <div className={css.comparisonHeaderCell}>
                        <FormattedMessage id="PricingPage.comparisonRecruitment" />
                      </div>
                      <div className={css.comparisonHeaderCell}>
                        <FormattedMessage id="PricingPage.comparisonAgency" />
                      </div>
                    </div>
                    <div className={css.comparisonRow}>
                      <div className={css.comparisonRowLabel}>
                        <FormattedMessage id="PricingPage.comparisonTimeToStart" />
                      </div>
                      <div className={css.comparisonCellPositive}>
                        <FormattedMessage id="PricingPage.comparisonDays" />
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonMonths" />
                        </span>
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonWeeks" />
                        </span>
                      </div>
                    </div>
                    <div className={css.comparisonRow}>
                      <div className={css.comparisonRowLabel}>
                        <FormattedMessage id="PricingPage.comparisonFlexibility" />
                      </div>
                      <div className={css.comparisonCellPositive}>
                        <FormattedMessage id="PricingPage.comparisonHigh" />
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonNone" />
                        </span>
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonVaries" />
                        </span>
                      </div>
                    </div>
                    <div className={css.comparisonRow}>
                      <div className={css.comparisonRowLabel}>
                        <FormattedMessage id="PricingPage.comparisonCosts" />
                      </div>
                      <div className={css.comparisonCellPositive}>
                        <FormattedMessage id="PricingPage.comparisonNone" />
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonVaries" />
                        </span>
                      </div>
                      <div className={css.comparisonCellNegative}>
                        <span>
                          <FormattedMessage id="PricingPage.comparisonHigh" />
                        </span>
                      </div>
                    </div>
                  </div>
                  <div className={css.browseIndicatorText}>
                    <IoIosArrowBack className={css.browseIndicatorArrow} />
                    <span className={css.browseIndicatorLabel}>
                      <FormattedMessage id="PricingPage.browseIndicator" />
                    </span>
                    <IoIosArrowForward className={css.browseIndicatorArrow} />
                  </div>
                </div>
              </div>
            </li>
            <li className={css.section}>
              <div className={css.sectionFAQContent}>
                <div className={css.sectionFAQTitle}>
                  <FormattedMessage id="PricingPage.faqSectionTitle" />
                </div>
                <FaqDropdown faqIsShown={faqIsShown} setFaqIsShown={setFaqIsShown} />
              </div>
            </li>
          </ul>
          <JoinPreFooter />
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
      </LayoutSingleColumn>
    </Page>
  );
};

PricingPageComponent.defaultProps = {
  currentUser: null,
};

PricingPageComponent.propTypes = {
  currentUser: propTypes.currentUser,
};

const mapStateToProps = state => {
  const { currentUser } = state.user;

  return {
    scrollingDisabled: isScrollingDisabled(state),
    currentUser,
  };
};

const PricingPage = compose(
  withRouter,
  connect(mapStateToProps),
  withViewport,
  injectIntl
)(PricingPageComponent);

export default PricingPage;
